import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { getDefectList } from "../../../jobCardDetails/services/apiCalls";
import { getTemperatureConditionList } from "../../services/apiCalls";
export var CustomerComplaintCard = [{
        type: FormItemTypes.CardComponent,
        name: "customerComplaint",
        label: "Customer complaint",
        sx: {
            mb: 8
        },
        columnSize: 12,
        elements: [{
                type: FormItemTypes.SearchSelect,
                label: "Performance",
                name: "PerformanceCodeId",
                value: null,
                required: true,
                displayExpr: "Name",
                valueExpr: "id",
                apiRequest: {
                    Name: "Performance"
                },
                getListData: getDefectList,
                getOptionLabel: function (option) { return option ? "".concat(option.ComplaintName, " - ").concat(option.ComplaintCode) : ""; }
            }, {
                type: FormItemTypes.SearchSelect,
                label: "Defect",
                name: "DefectCodeId",
                value: null,
                required: true,
                displayExpr: "Name",
                valueExpr: "id",
                apiRequest: {
                    Name: "Part Defect Code"
                },
                getListData: getDefectList,
                getOptionLabel: function (option) { return option ? "".concat(option.ComplaintName, " - ").concat(option.ComplaintCode) : ""; }
            }, {
                type: FormItemTypes.TextInput,
                name: "ProblemDescription",
                label: "Problem description",
                placeholder: "E.g. Ganesh Tavade",
                required: true,
                validator: function (value) {
                    var leadingSpacesRegex = /^\S.*$/;
                    if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                        return "Leading spaces are not allowed.";
                    }
                    return undefined;
                }
            }, {
                type: FormItemTypes.SearchSelect,
                label: "Temperature Condition",
                name: "TemperatureConditionId",
                value: null,
                required: false,
                getListData: getTemperatureConditionList,
                displayExpr: "Name",
                valueExpr: "id"
            }, {
                type: FormItemTypes.TextInput,
                name: "VehicleSpeed",
                label: "Vehicle speed",
                value: "",
                placeholder: "E.g 70 kmph",
                required: true,
                validator: function (value) {
                    var conditionRegex = /^[0-99\s]+$/;
                    if (!conditionRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                        return "Only numbers are allowed";
                    }
                    if ((value === null || value === void 0 ? void 0 : value.length) < 2) {
                        return "Vehicle speed must be at least 2 digits";
                    }
                    if ((value === null || value === void 0 ? void 0 : value.length) > 3) {
                        return "Vehicle speed must be no longer than 3 digits";
                    }
                    return undefined; // No errors
                }
            }, {
                type: FormItemTypes.TextInput,
                name: "RoadCondition",
                label: "Road Condition",
                placeholder: "E.g. Gravel",
                required: true,
                validator: function (value, state) {
                    var conditionRegex = /^[A-Za-z\s]+$/; // Only letters and spaces
                    var leadingSpacesRegex = /^\S.*$/;
                    if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                        return "Leading spaces are not allowed.";
                    }
                    if (!conditionRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                        return "Only alphabetic characters are allowed";
                    }
                    if ((value === null || value === void 0 ? void 0 : value.length) < 2) {
                        return "Road condition must be at least 2 characters";
                    }
                    if ((value === null || value === void 0 ? void 0 : value.length) > 10) {
                        return "Road condition must be no longer than 10 characters";
                    }
                    return undefined;
                }
            }]
    }];
